"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Transactions = void 0;
var _reactResponsive = require("react-responsive");
var _react = _interopRequireDefault(require("react"));
var _interfaces = require("../../interfaces");
var _utils = require("../../utils");
var _ui = require("../ui");
var _Cards = require("./Cards");
var _LoadMore = require("./LoadMore");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Transactions = function Transactions(_ref) {
  var _statusDotColor;
  var transactions = _ref.transactions,
    loadMore = _ref.loadMore,
    hasMore = _ref.hasMore,
    isLoading = _ref.isLoading,
    isCSVLoading = _ref.isCSVLoading,
    TableComponent = _ref.tableComponent,
    cardComponent = _ref.cardComponent,
    onTransactionClick = _ref.onTransactionClick,
    NoData = _ref.noData,
    showModalViewAll = _ref.showModalViewAll;
  var isMobile = (0, _reactResponsive.useMediaQuery)({
    maxWidth: _utils.breakpoints.lg
  });
  var statusDotColor = (_statusDotColor = {}, _defineProperty(_statusDotColor, _interfaces.TransactionStatus.DONE, 'success'), _defineProperty(_statusDotColor, _interfaces.TransactionStatus.FAILED, 'danger'), _defineProperty(_statusDotColor, _interfaces.TransactionStatus.CREATED, 'primary'), _defineProperty(_statusDotColor, _interfaces.TransactionStatus.PENDING, 'primary'), _defineProperty(_statusDotColor, _interfaces.TransactionStatus.QUEUED, 'primary'), _defineProperty(_statusDotColor, _interfaces.TransactionStatus.MINED, 'primary'), _defineProperty(_statusDotColor, _interfaces.TransactionStatus.EXPIRED, 'danger'), _statusDotColor);
  if (!transactions) return /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex justify-content-center align-items-center flex-grow-1"
  }, /*#__PURE__*/_react.default.createElement(_ui.Spinner, {
    size: !isMobile && 'lg',
    color: "primary"
  }));
  if (!transactions.length) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, NoData);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isMobile ? /*#__PURE__*/_react.default.createElement(_Cards.Cards, {
    statusDotColor: statusDotColor,
    transactions: transactions,
    cardComponent: cardComponent,
    onRowClick: onTransactionClick,
    showModalViewAll: showModalViewAll
  }) : /*#__PURE__*/_react.default.createElement(TableComponent, {
    statusDotColor: statusDotColor,
    transactions: transactions,
    loadMore: loadMore,
    hasMore: hasMore,
    isLoading: isLoading,
    isCSVLoading: isCSVLoading,
    onRowClick: onTransactionClick,
    showModalViewAll: showModalViewAll
  }), hasMore && /*#__PURE__*/_react.default.createElement(_LoadMore.LoadMore, {
    onClick: loadMore,
    isLoading: isLoading
  }));
};
exports.Transactions = Transactions;